import React, { useState } from "react";
import { Typography } from "@mui/material";
import { useKeycloak } from "@react-keycloak/web";
import { Button, TextField as Input } from "@mui/material";
import SIZE from "../theme/colors.json";
import COLORS from "../theme/colors.json";
import { request } from "../services/request";
import CONSTANTS from "../constants/constants";
import { makeStyles } from "@mui/styles";
import { Avatar, Tooltip } from "@mui/material";

const useStyles = makeStyles(() => ({
  profileContainer: {
    display: "flex",
    flexDirection: "column",
    // justifyContent: "center",
    // alignItems: "center",
    padding: "3%",
    gap: "3vh",
  },
  profileFieldsSection: {
    display: "flex",
    flexDirection: "row",
    gap: "2%",
  },
  profileLogo: {
    width: "12rem !important",
    height: "12rem !important",
  },
  profileLogoSection: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  profileFlexRow: {
    display: "flex",
    flexDirection: "row",
    gap: "2%",
  },
  btnSection: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  label: {
    marginBottom: SIZE[0],
    fontSize: SIZE[15],
    textAlign: "left",
    color: COLORS.GRAY,
    width: "100%",
    pointerEvents: "none",
  },
}));

const Profile = (props) => {
  const { logo } = props;
  const classes = useStyles();
  const size = "small";
  const variant = "standard";
  const [firstName, setFirstName] = useState(
    sessionStorage.getItem(CONSTANTS.FIRST_NAME)
  );
  const [lastName, setLastName] = useState(
    sessionStorage.getItem(CONSTANTS.LAST_NAME)
  );

  const USER_ID = `${sessionStorage.getItem(CONSTANTS.USER_ID)}`;
  const USER_MAIL = `${sessionStorage.getItem(CONSTANTS.USER_EMAIL)}`;

  return (
    <div className={classes.profileContainer}>
      <div className={classes.profileLogoSection}>
        <Tooltip title={logo.title} placement="right" arrow>
          <Button id="logo-button-profile">
            <Avatar
              alt="logo-profile"
              src={logo.icon}
              className={classes.profileLogo}
            />
          </Button>
        </Tooltip>
      </div>
      <div className={classes.profileFieldsSection}>
        <Input
          label="User Email"
          value={sessionStorage.getItem("user-email")}
          name="userEmail"
          type="text"
          size={size}
          className={classes.label}
          variant={variant}
        />
        <Input
          label="First Name"
          value={firstName}
          name="first-name"
          type="text"
          size={size}
          className={classes.label}
          variant={variant}
        />
        <Input
          label="Last Name"
          value={lastName}
          name="last-name"
          type="text"
          size={size}
          className={classes.label}
          variant={variant}
        />
      </div>
    </div>
  );
};

export default Profile;
